import { render, staticRenderFns } from "./ShopSettingsFields.vue?vue&type=template&id=21cc357b&scoped=true&lang=pug&"
import script from "./ShopSettingsFields.vue?vue&type=script&lang=js&"
export * from "./ShopSettingsFields.vue?vue&type=script&lang=js&"
import style0 from "./ShopSettingsFields.vue?vue&type=style&index=0&id=21cc357b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc357b",
  null
  
)

export default component.exports